export default function (entity, collision) {

    entity.remove('hitbox');
};
